<template>
  <el-row>
    <el-row class="movie-list">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>审批工作流</span>
        </div>
        <div class="text item">
          <el-table
            :data="approvalRequests"
            border
            style="width: 100%"
          >
            <el-table-column
              prop="id"
              label="ID"
            />
            <el-table-column
              prop="createAt"
              label="创建时间"
            />
            <el-table-column
              prop="bizType"
              label="业务类型"
            />
            <el-table-column
              prop="userId"
              label="请求用户"
            />
            <el-table-column
              fixed="right"
              label="操作"
            >
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  @click="onApprove(scope.row)"
                >同意</el-button>
                <el-button
                  size="mini"
                  type="danger"
                  @click="onDecline(scope.row)"
                >拒绝</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-card>
    </el-row>
  </el-row>
</template>

<script>
import { userMixin } from 'assets/js/mixin'
import { getVipPlan } from '@/api/admin'
import { auditApprovalRequest, getApprovalRequests } from '@/api/user'

export default {
  name: 'AdminApproval',
  mixins: [userMixin],
  data() {
    return {
      approvalRequests: [],
      vipPlanList: []
    }
  },
  created() {
    getVipPlan().then(resp => {
      if (resp.code === 0) {
        this.vipPlanList = resp.data
      } else {
        this.$message.error(resp.msg)
      }
    })

    this.getData()
  },
  methods: {
    getData() {
      const queryParams = {}
      queryParams.pn = 1
      getApprovalRequests(queryParams).then(resp => {
        if (resp.code === 0) {
          this.approvalRequests = resp.data.list
        } else {
          this.$message.warning(resp.msg)
        }
      })
    },
    onApprove(row) {
      const payload = {}
      payload.requestId = row.id
      payload.action = 1
      payload.remark = ''
      this.audit(payload)
    },
    onDecline(row) {
      const payload = {}
      payload.requestId = row.id
      payload.action = 2
      payload.remark = ''
      this.audit(payload)
    },
    audit(payload) {
      auditApprovalRequest(payload).then(resp => {
        this.$message.warning(resp.msg)
      })
    }
  }
}
</script>

<style>
</style>
